<template>
  <div>
    <section v-if="isDialog">
      <div v-if="visible" transition="dialog-scale-transition">
        <v-card class="mx-auto">
          <v-toolbar v-if="showTopToolbar" dark color="primary" height="35">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn small icon color="primary" @click="onClose"><v-icon>close</v-icon></v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <slot></slot>
        </v-card>
      </div>
    </section>
    <section v-else>
      <kendo-window
        ref="window"
        :width="width"
        :height="height"
        :title="title"
        :modal="modal"
        @close="onClose"
        @open="onOpen"
        v-if="visible"
        :visible="visible"
      >
        <slot></slot>
      </kendo-window>
    </section>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  model: {
    prop: 'visible',
    event: 'close',
  },
  props: {
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    title: {
      type: String,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    showTopToolbar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  watch: {
    visible: {
      immediate: true,
      handler(newValue) {
        if (newValue === true && !this.isDialog) {
          Vue.nextTick(() => {
            this.$refs.window
              .kendoWidget()
              .open()
              .center()
          })
        }
      },
    },
  },
  methods: {
    onOpen() {
      if (this.visible) {
        if (!this.isDialog) {
          this.$refs.window.kendoWidget().center()
        }
      }
    },
    onClose() {
      this.$emit('close', false)
    },
  },
}
</script>
